<template>
  <v-dialog v-model="dialog" persistent width="400px">
    <template v-slot:activator="{ on }">
      <v-btn
        small
        tile
        outlined
        depressed
        color="primary"
        dark
        v-on="on"
        @click="openDialog()"
        ><v-icon small color="primary">mdi-plus</v-icon>Upload Report</v-btn
      >
    </template>

    <v-card v-if="dialog">
      <validation-observer v-slot="{ invalid }">
        <v-card-title>Upload Report</v-card-title>
        <v-card-text>
          <validation-provider :rules="{ required: true }" v-slot="{ errors }">
            <v-autocomplete
              v-model="programId"
              label="Program"
              :items="rsPrograms"
              item-text="name"
              item-value="programId"
              dense
              :error-messages="errors"
            ></v-autocomplete>
          </validation-provider>
          <validation-provider :rules="{ required: true }" v-slot="{ errors }">
            <v-autocomplete
              v-model="semesterId"
              label="Semester"
              :items="semesters"
              :item-text="
                (item) => `${item.semesterCode} - ${item.semesterDescription}`
              "
              item-value="semesterId"
              dense
              :error-messages="errors"
            ></v-autocomplete>
          </validation-provider>
          <validation-provider :rules="{ required: true }" v-slot="{ errors }">
            <v-file-input
              v-model="selectedFile"
              prepend-icon="mdi-paperclip"
              label="Upload Report (xlsx)"
              accept=".xls, .xlsx"
              chips
              single-line
              :error-messages="errors"
            ></v-file-input>
          </validation-provider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="clear"> Cancel </v-btn>
          <v-btn
            color="primary"
            outlined
            :dark="!invalid"
            :disabled="invalid"
            @click="uploadTransmittalReport"
            >Upload
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      programId: 3, // CSE Related Services
      semesterId: "",
      selectedFile: null,
    };
  },
  computed: {
    rsPrograms() {
      return this.$store.getters["optionsModule/getRelatedServicesPrograms"];
    },
    semesters() {
      return this.$store.state.optionsModule.semesters;
    },
    currentSemester() {
      return this.$store.getters["optionsModule/getCurrentSemester"];
    },
  },
  methods: {
    openDialog() {
      this.dialog = true;
      this.semesterId = this.currentSemester?.semesterId;
    },
    async uploadTransmittalReport() {
      this.dialog = false;
      this.$store.commit("uxModule/setShowLoader", true);
      let message = await this.$store.dispatch(
        "transmittalsModule/uploadTransmittalReport",
        {
          programId: this.programId,
          semesterId: this.semesterId,
          selectedFile: this.selectedFile,
        }
      );
      this.$store.commit("uxModule/setShowLoader", false);
      if (message) {
        this.$store.commit("uxModule/setSnackbarMsg", message);
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
      this.clear();
    },
    clear() {
      this.selectedFile = null;
      this.dialog = false;
    },
  },
};
</script>
